import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("nq-logout", onLogout);
    return () => window.removeEventListener("nq-logout", onLogout);
  }, []);

  const accept = useCallback((data) => { localStorage.setItem(TOKEN_KEY, data.token); setUser(data.user); }, []);
  const login = useCallback(async (email, password) => accept((await api.post("/auth/login", { email, password })).data), [accept]);
  const register = useCallback(async (email, password, name) => accept((await api.post("/auth/register", { email, password, name })).data), [accept]);
  const logout = useCallback(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); }, []);

  return <AuthCtx.Provider value={{ user, login, register, logout, isAdmin: user?.role === "admin" }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
